import React from 'react';
import styled from 'styled-components';

const LogoImage = styled.img`
  max-height: 100%;
  max-width: 100%;
`;

const Logo: React.FC = React.memo(() => {
  return (
      <LogoImage src={`/media/Logo.svg`} alt="Logo" />
  );
});

export default Logo;